import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { TABLE_BASE_COMMON_IMPORTS } from '../../../material-base-common-imports';
import { AlertItem } from '../../../biographics/pending.model';
import { NgClass } from '@angular/common';
import { ThrottleClickDirective } from '@drc-eca/eca-lrc-common-ui';
import { AlertTypePipe } from '../../alert-type.pipe';

@Component({
  selector: 'eca-alerts-review-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [...TABLE_BASE_COMMON_IMPORTS, ThrottleClickDirective, NgClass, AlertTypePipe]
})
export class AlertsReviewTableComponent {

  /*@Input() set filter(filterValue: string) {
    if (typeof filterValue === 'string') {
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }*/

  @Input() set data(data: AlertItem[]) {
    this.dataSource.data = data;
  }

  @Output() view = new EventEmitter<AlertItem>();

  active: AlertItem;
  dataSource: MatTableDataSource<AlertItem>;
  displayedColumns = [
    'pageId',
    'question',
    'alertType',
  ];

  onView(alert: AlertItem) {
    this.active = alert;
    this.view.emit(alert);
  }

  constructor() {
    this.dataSource = new MatTableDataSource<AlertItem>([]);
  }

}
